import { Chip } from '@mui/material'
import React from 'react'
import { makeStyles } from '@mui/material'
import { colors } from 'theme'

function NeoChip({ label }) {
  return (
    <>
     <Chip
        label={label}
        disabled={false}
        size="medium"
        variant="filled"
        sx={{
            bgcolor: `#AD9AFF3B`,
            width: '300px',
            borderRadius: "10px",
            height: '50px',
            fontSize: '14px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        />
    </>
  )
}

export default NeoChip

const ChisStyleing = {
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}